import { PaletteMode } from '@mui/material';
import { ChronosphereColorPalette, green } from '../colors';
import { GetThemeOptions } from '../../theme';
import {
  chronoDefinedDarkTokens,
  chronoDefinedLightTokens,
  unitySemanticDarkColorTokens,
  unitySemanticLightColorTokens,
} from '@/theme/unityTokens';

export const successColor = (mode: PaletteMode, opts: GetThemeOptions): ChronosphereColorPalette => {
  if (opts.panwRebrandStubYear) {
    const semanticTokens = mode === 'light' ? unitySemanticLightColorTokens : unitySemanticDarkColorTokens;
    const chronoTokens = mode === 'light' ? chronoDefinedLightTokens : chronoDefinedDarkTokens;
    return {
      main: semanticTokens['--semantic-data-informative-positive'],
      highContrast: chronoTokens['--data-informative-positive-high-contrast'],
      lowContrast: chronoTokens['--data-informative-positive-low-contrast'],
    };
  }

  return mode === 'light'
    ? {
        main: green[500],
        highContrast: green[700],
        lowContrast: green[100],
      }
    : {
        main: green[400],
        highContrast: green[100],
        lowContrast: green[800],
      };
};
